<template>
    <div :class="flashStyle" v-if="isVisible">
        <button
            v-if="type !== 'info'"
            type="button"
            class="close"
            aria-label="Close"
            data-cy="closeFlash"
            @click="closeFlash"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <p data-cy="flashContent">{{ message }}</p>
        <button
            v-if="type === 'info'"
            type="button"
            class="btn btn-light mt-10"
            aria-label="Continue"
            data-cy="closeFlash"
            @click="closeInfoFlash"
        >
            Continue
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            isVisible: false,
            type: '',
            message: '',
            dismissTimer: null
        };
    },

    computed: {
        ...mapState('ui', ['flashMessage']),

        flashStyle() {
            return `alert alert-${this.type} fade in`;
        }
    },

    watch: {
        flashMessage: {
            deep: true,
            handler(flash) {
                if (!flash || !flash.message) return;
                this.newFlash();
            }
        }
    },

    beforeDestroy() {
        this.clearDismissTimer();
    },

    methods: {
        newFlash() {
            this.clearDismissTimer();

            this.message = this.flashMessage.message;
            this.type = this.flashMessage.type;
            this.isVisible = true;

            if (this.type === 'success') {
                this.dismissTimer = setTimeout(() => {
                    this.closeFlash();
                }, 7000);
            }
        },

        closeFlash() {
            this.clearDismissTimer();
            this.isVisible = false;
            this.type = '';
            this.message = '';
        },

        closeInfoFlash() {
            this.closeFlash();
            this.$emit('MESSAGE_CLEARED');
        },

        clearDismissTimer() {
            if (this.dismissTimer) {
                clearTimeout(this.dismissTimer);
                this.dismissTimer = null;
            }
        }
    }
};
</script>
